import { render, staticRenderFns } from "./addinsurance.vue?vue&type=template&id=66974c14&"
import script from "./addinsurance.vue?vue&type=script&lang=js&"
export * from "./addinsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports